

















import {Component, Prop, Vue} from "vue-property-decorator";
import {PriceListStore} from "@/modules/pricelists/store";
import {PriceList} from "@/interfaces/entity";

@Component({
    name: "PriceListTableAction"
})
export default class extends Vue {
    @Prop({ required: true, type: Number })
    readonly priceListId!: number;

    get priceList(): PriceList {
        return PriceListStore.data[this.priceListId];
    }

    set priceList(value: PriceList) {
        PriceListStore.data[this.priceListId] = value;
    }
    async onConfirm() {
        try {
            await PriceListStore.deletePriceList(this.priceListId);
            this.$notification.success({
                message: "Thành công",
                description: "Xóa bảng giá thành công"
            });
        } catch (e) {
            this.$notification.error({
                message: "Thất bại",
                description: "Xóa bảng giá thất bại"
            });
        }
    }
}
